import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query"
import { ISubstitutionRequest } from "./types"
import api from "services/api"

export function useSubstitutionRequests(
  params?: any,
  config?: UseQueryOptions<ISubstitutionRequest[]>
) {
  return useQuery<ISubstitutionRequest[]>(
    ["suite", "time", "assignations", "requests", params],
    {
      keepPreviousData: true,
      ...config,
    }
  )
}

export function useApplyToSubstitute(
  substitutionId: string,
  config?: UseMutationOptions<unknown, unknown, { comment?: string }>
) {
  const queryClient = useQueryClient()
  return useMutation(
    (data) =>
      api.post(
        `suite/time/assignations/substitutions/${substitutionId}/propositions`,
        data
      ),
    {
      ...config,
      onSuccess(data, vars, conext) {
        config?.onSuccess?.(data, vars, conext)
        queryClient.invalidateQueries([
          "suite",
          "time",
          "assignations",
          "requests",
        ])
      },
    }
  )
}

export function useDeleteSubstitutionApplication(
  substitutionId: string,
  config?: UseMutationOptions<unknown, unknown, string>
) {
  const queryClient = useQueryClient()
  return useMutation(
    (applicationId) =>
      api.delete(
        `suite/time/assignations/substitutions/${substitutionId}/propositions/${applicationId}`
      ),
    {
      ...config,
      onSuccess(data, vars, conext) {
        config?.onSuccess?.(data, vars, conext)
        queryClient.invalidateQueries([
          "suite",
          "time",
          "assignations",
          "requests",
        ])
      },
    }
  )
}
